/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

import TaskBoard from "./TaskBoard";
import { useHistory } from "react-router";
// Redux Store
import queryString from "query-string";
import TaskHandoverPopup from "../../components/Task/TaskHandoverPopup";
import systemAlert from "../../utils/systemAlert";
import { shallowEqual, useSelector } from "react-redux";
import { isEmpty } from "../../utils/lodashExtend";
import { permissionCheck } from "../../utils/permission";

const Task = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState();
  const { permissions, user } = useSelector((store) => ({
    permissions: store.Profile.permissions,
    user: store.Profile.user,
  }), shallowEqual);
  const [targetPermission, setTargetPermission] = useState(null);
  const [tabList, setTabList] = useState([]);
  // const { company } = useSelector((store) => ({ company: store.Profile.company }))

  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`
    });
    setActiveTab(value);
  };

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'TODO');
      setTargetPermission(permission);

      if (isEmpty(permission)) {
        permissionCheck(history, 'TODO');
      }
    }
  }, [permissions]);

  useEffect(() => {
    if (user) {
      if (user.companyType === 1 && (user.type === 2 || user.type === 3 || user.type === 9)) {
        setTabList([
          {
            isHide: targetPermission && targetPermission.level < 3,
            label: "전체 할일",
            action: _setActiveTab,
            owner: 'all',
            value: 'all'
          }
        ]);
      } else {
        setTabList([
          {
            label: "내가 할일",
            action: _setActiveTab,
            owner: 'owner',
            value: 'owner',
          },
          {
            label: "내가 요청한 할일",
            action: _setActiveTab,
            owner: 'requester',
            value: 'requester',
          },
          {
            label: "참조된 할일",
            action: _setActiveTab,
            owner: 'reference',
            value: 'reference',
          },
          {
            isHide: targetPermission && targetPermission.level < 3,
            label: "전체 할일",
            action: _setActiveTab,
            owner: 'all',
            value: 'all'
          }
        ]);
      }

    }
  }, [user, targetPermission]);

  // const tabList = [
  //   {
  //     label: "내가 할일",
  //     action: _setActiveTab,
  //     owner: 'owner',
  //     value: 'owner',
  //   },
  //   {
  //     label: "내가 요청한 할일",
  //     action: _setActiveTab,
  //     owner: 'requester',
  //     value: 'requester',
  //   },
  //   {
  //     label: "참조된 할일",
  //     action: _setActiveTab,
  //     owner: 'reference',
  //     value: 'reference',
  //   },
  //   {
  //     isHide: targetPermission.level < 3,
  //     label: "전체 할일",
  //     action: _setActiveTab,
  //     owner: 'all',
  //     value: 'all'
  //   }
  // ];


  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || (!isEmpty(tabList) && tabList[0].value));
  }, [history.location, tabList]);


  const headerButtons = [
    // {
    //   label: "할일 위임",
    //   action: () => {
    //     setIsApprovalsHandoverPopup(true)
    //   }
    // },
  ];

  const [isApprovalsHandoverPopup, setIsApprovalsHandoverPopup] = useState(false);

  const [employeeSelectedList, setEmployeeSelectedList] = useState([]);
  const approvalsHandoverPopupClose = () => {
    setIsApprovalsHandoverPopup(false);
    // setHandoverReason('')
    setEmployeeSelectedList([]);
  };
  const approvalsHandoverPopupSubmit = ({ date, handoverReason, employeeSelectedList }) => {
    //console.log(date, handoverReason, employeeSelectedList);
    if (!employeeSelectedList[0]) {
      systemAlert('위임대상을 선택해주세요.');
      return;
    }
    alert('위임이 불가합니다.');
    approvalsHandoverPopupClose(false);
    // approvalsHandover({
    //   taskIdxes: taskSelectedList.map(d => d.idx),
    //   targetEmpIdx: employeeSelectedList[0].idx,
    //   startDate: "2020-03-03",
    //   endDate: "2030-10-100",
    //   reason: handoverReason
    // }).then(() => {
    //   // 전체 위임은 새로고침
    //   window.location.reload();
    // }).catch(() => { })
  };

  return (
    !isEmpty(targetPermission) && !isEmpty(tabList) && (
      <div className="print-out">
        <PageHeader
          title="할일"
          activeTab={activeTab}
          tabList={tabList}
          buttons={headerButtons}
        />

        {tabList.map((tab, idx) => (
          <React.Fragment key={idx}>
            {tab.value === activeTab ?
              <TaskBoard ownership={tab.owner} />
              : <></>}
          </React.Fragment>
        ))}

        <TaskHandoverPopup
          isOpen={isApprovalsHandoverPopup}
          close={approvalsHandoverPopupClose}
          // taskSelectedList={selectedList}
          employeeSelectedList={employeeSelectedList}
          setEmployeeSelectedList={setEmployeeSelectedList}
          submit={approvalsHandoverPopupSubmit}
        ></TaskHandoverPopup>
      </div>
    )
  );
};

export default Task;